import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { getContentObjectives } from "../lib/requestFunctions";

export function useLearningOutcomes(
    selectedClass: string | undefined,
    selectedSubject: string | undefined,
    selectedStrand: string | undefined,
    selectedStrandUnit: string | undefined,
    enabled: boolean,
) {
    const [selectedLearningOutcome, setSelectedLearningOutcome] = useState<string | undefined>(
        undefined,
    );

    const {
        status: learningOutcomeStatus,
        fetchStatus: learningOutcomeFetchStatus,
        data: learningOutcomes,
    } = useQuery({
        queryKey: ["learningOutcomes", selectedClass, selectedSubject, selectedStrand, selectedStrandUnit],
        queryFn: () =>
            getContentObjectives(
                selectedClass ? [parseInt(selectedClass)] : [],
                selectedSubject ? [parseInt(selectedSubject)] : [],
                selectedStrand ? [parseInt(selectedStrand)] : [],
                selectedStrandUnit ? [parseInt(selectedStrandUnit)] : [],
            ),
        enabled: !!selectedClass && !!selectedSubject && !!selectedStrand && !!selectedStrandUnit && enabled,
    });

    useEffect(() => {
        setSelectedLearningOutcome(undefined);
    }, [selectedClass, selectedSubject, selectedStrand, selectedStrandUnit]);

    const learningOutcomesData = learningOutcomes?.data?.map((outcome) => ({
        key: outcome.id,
        text: outcome.content,
    })) ?? [];

    return {
        selectedLearningOutcome,
        setSelectedLearningOutcome,
        learningOutcomesData,
        learningOutcomeStatus,
        learningOutcomeFetchStatus,
        learningOutcomesError: learningOutcomeStatus === 'error',
    };
}